import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export function CubeRSENoir(props) {
  const { nodes, materials } = useGLTF("./models/assets/cubeRSENoir.glb");
  return (
    <group {...props} dispose={null}>
      <group scale={0.7}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube034.geometry}
          material={materials.Material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube034_1.geometry}
          material={materials.RSE_BlackBox}
        />
      </group>
    </group>
  );
}

useGLTF.preload("./models/assets/cubeRSENoir.glb");
